module.exports = __webpack_public_path__ + "static/img/1.f1c8e02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/mOfficial/1.png
// module id = aW5X
// module chunks = 1